import { Box, Divider } from '@mui/material'

interface ComponentCatalogSectionProps {
  children: React.ReactNode
  name: string
}

export const ComponentCatalogSection = ({
  children,
  name,
}: ComponentCatalogSectionProps) => {
  return (
    <Box className="my-10">
      <pre className="font-bold">{name}</pre>
      <Divider />
      <Box className="py-5">{children}</Box>
    </Box>
  )
}
